import Slider from './slider'

class AboutSlider extends Slider {
    constructor(selector, options) {
        super(selector, options);
    }
}

module.exports = AboutSlider;